import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  CircularProgress,
} from '@mui/material';
import AreaChart from './AreaChart';
import { TrendingUp } from '@mui/icons-material';

const TrendChart = ({
  title = "Trend Chart",
  data = [],
  loading = false,
  height = 400,
  dataKey = 'value',
  labelKey = 'label',
  valueFormatter,
  emptyMessage = "No data available for the selected period."
}) => {
  // Handle responsive height
  const getResponsiveHeight = (height) => {
    if (typeof height === 'object') {
      return height;
    }
    return { xs: Math.min(height, 300), sm: Math.min(height, 350), md: height };
  };

  const responsiveHeight = getResponsiveHeight(height);


  return (
    <Card sx={{
      borderRadius: 1,
      border: '0 solid #fff',
      boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
      bgcolor: '#fff'
    }}>
      <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
        <Typography variant="h3" sx={{
          fontWeight: 600,
          color: '#1f1f1f',
          mb: 3,
          fontSize: '1.5rem',
          letterSpacing: '-0.025em',
          lineHeight: 1,
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem'
        }}>
          <TrendingUp fontSize='12px' />
          {title}
        </Typography>

        {loading ? (
          <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: responsiveHeight,
            bgcolor: '#f8fafc',
            borderRadius: 2,
            gap: 2
          }}>
            <CircularProgress size={40} sx={{ color: '#14b8a6' }} />
            <Typography color="#737373" sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}>
              Loading chart data...
            </Typography>
          </Box>
        ) : data.length > 0 ? (
          <Box sx={{
            height: responsiveHeight,
            width: '100%',
            minHeight: { xs: 250, sm: 300 }
          }}>
            <AreaChart
              data={data}
              dataKey={dataKey}
              xAxisKey="label"
              valueFormatter={valueFormatter}
              yAxisFormatter={valueFormatter}
              tooltipFormatter={(value) => valueFormatter ? valueFormatter(value) : value}
              tooltipLabelFormatter={(label) => label}
            />
          </Box>
        ) : (
          <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: responsiveHeight,
            bgcolor: '#f8fafc',
            borderRadius: 2
          }}>
            <Typography
              color="#737373"
              sx={{
                fontSize: { xs: '0.875rem', sm: '1rem' },
                textAlign: 'center',
                px: 2
              }}
            >
              {emptyMessage}
            </Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default TrendChart;